export default {
      id: "icon-calendar-usage",
      viewBox: "0 0 17.067 18.38",
      url: __webpack_public_path__ + "img/icons.c8a27ec6.svg#icon-calendar",
      toString: function () {
        return this.url;
      }
    }